<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
      <section ref="content" id="content" class="section">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <QrScanner ref="qrScanner" :className.sync="qrScanner.className"></QrScanner>
          <div v-show="panel == 'main'">
            <div class="columns is-mobile is-centered">
                <div class="column is-two-thirds has-text-centered">
                    <a @click="show('tag')" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-tag"></i>
                        </span>
                        <span>{{ $t("SearchByTag") }}</span>
                    </a>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-two-thirds has-text-centered">
                    <a @click="show('mobile')" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-mobile"></i>
                        </span>
                        <span>{{ $t("SearchByMobile") }}</span>
                    </a>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-two-thirds has-text-centered">
                    <a @click="show('advanced')" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-search"></i>
                        </span>
                        <span>{{ $t("AdvancedSearch") }}</span>
                    </a>
                </div>
            </div>
        </div>
        <div v-show="panel == 'tag'">
            <div class="columns is-mobile is-centered">
                <div class="column is-full has-text-centered">
                    <div class="control has-icons-left has-icons-right">
                        <input ref="nfcId" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="text" autocomplete="off" v-model="nfcId" :placeholder="$t('TagID')" pattern="[A-Fa-f0-9]+" maxlength="8" required>
                        <span class="icon is-small is-left">
                            <i class="fa fa-tag"></i>
                        </span>
                        <span @click="scanQr()" :title="$t('ClickToScanQrCode')" class="icon clickable is-small is-right">
                            <i class="fa fa-qrcode"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-half has-text-centered">
                    <a @click="search()" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa" :class="[loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                        </span>
                        <span>{{ $t("Search") }}</span>
                    </a>
                </div>
                <div class="column is-half has-text-centered">
                    <a @click="show('main')" class="button is-info is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-times"></i>
                        </span>
                        <span>{{ $t("Cancel") }}</span>
                    </a>
                </div>
            </div>
        </div>
        <div v-show="panel == 'mobile'">
            <div class="columns is-mobile is-centered">
                <div class="column is-half">
                    <div class="control has-icons-left">
                        <div class="select is-fullwidth">
                            <div class="select is-fullwidth">
                                <select ref="callingCode" v-model="callingCode" required>
                                    <option disabled value="disabled">{{ $t("Country")}}</option>
                                    <option v-for="country in countries" :key="country.id" :value="country.callingCode">{{ country.name }} (+{{ country.callingCode }})</option>
                                </select>
                            </div>
                        </div>
                        <div class="icon is-small is-left">
                            <i class="fa fa-globe"></i>
                        </div>
                    </div>
                </div>
                <div class="column is-half">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input ref="mobile" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input no-spinner" type="number" :placeholder="$t('Mobile')" v-model="mobile" required autocomplete="off" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-phone"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-half has-text-centered">
                    <a @click="search()" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa" :class="[loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                        </span>
                        <span>{{ $t("Search") }}</span>
                    </a>
                </div>
                <div class="column is-half has-text-centered">
                    <a @click="show('main')" class="button is-info is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-times"></i>
                        </span>
                        <span>{{ $t("Cancel") }}</span>
                    </a>
                </div>
            </div>
        </div>
        <div v-show="panel == 'advanced'">
            <div class="columns is-mobile is-centered">
                <div class="column is-full has-text-centered">
                    <div class="control has-icons-left has-icons-right">
                        <input @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="text" autocomplete="off" v-model="nfcId" :placeholder="$t('TagID')" pattern="[A-Fa-f0-9]+" maxlength="8">
                        <span class="icon is-small is-left">
                            <i class="fa fa-tag"></i>
                        </span>
                        <span @click="scanQr()" :title="$t('ClickToScanQrCode')" class="icon clickable is-small is-right">
                            <i class="fa fa-qrcode"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-half">
                    <div class="control has-icons-left">
                        <div class="select is-fullwidth">
                            <div class="select is-fullwidth">
                                <select v-model="callingCode">
                                    <option disabled value="disabled">{{ $t("Country")}}</option>
                                    <option v-for="country in countries" :key="country.id" :value="country.callingCode">{{ country.name }} (+{{ country.callingCode }})</option>
                                </select>
                            </div>
                        </div>
                        <div class="icon is-small is-left">
                            <i class="fa fa-globe"></i>
                        </div>
                    </div>
                </div>
                <div class="column is-half">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input no-spinner" type="number" :placeholder="$t('Mobile')" v-model="mobile" autocomplete="off" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-phone"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-full has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input ref="name" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="text" :placeholder="$t('Name')" v-model="name" autocomplete="off">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-full">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input ref="address" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="text" :placeholder="$t('Address')" v-model="address" autocomplete="off">
                            <span class="icon is-small is-left">
                                <i class="fa fa-map-marker"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-half">
                    <div class="control has-icons-left">
                        <input ref="lastUsageDateStart" class="input" type="date" :placeholder="$t('LastUsageDateStart')" v-model="lastUsageDateStart">
                        <span class="icon is-small is-left">
                            <i class="fa fa-calendar"></i>
                        </span>
                    </div>
                </div>
                <div class="column is-half">
                    <div class="control has-icons-left">
                        <input ref="lastUsageDateEnd" class="input" type="date" :placeholder="$t('LastUsageDateEnd')" v-model="lastUsageDateEnd">
                        <span class="icon is-small is-left">
                            <i class="fa fa-calendar"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-full">
                    <div class="control has-icons-left">
                        <div class="select is-fullwidth">
                            <select ref="waterSystem" @change="updateTaps()" v-model="systemID">
                                <option disabled value="disabled">{{ $t("WaterSystem")}}</option>
                                <option v-for="waterSystem in waterSystems" :key="waterSystem.waterSystemID" :value="waterSystem.waterSystemID">{{ waterSystem.name }}</option>
                            </select>
                        </div>
                        <div class="icon is-small is-left">
                            <i class="fa fa-tint"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-full">
                    <div class="control has-icons-left">
                        <div class="select is-fullwidth">
                            <select ref="asset" v-model="assetID">
                                <option disabled value="disabled">{{ $t("Tap")}}</option>
                                <option v-for="asset in assets" :key="asset.assetID" :value="asset.assetID">{{ asset.name }} ({{ asset.connected ? $t("Online") : $t("Offline") }})</option>
                            </select>
                        </div>
                        <div class="icon is-small is-left">
                            <i class="fa fa-tint"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-half has-text-centered">
                    <a @click="search()" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa" :class="[loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                        </span>
                        <span>{{ $t("Search") }}</span>
                    </a>
                </div>
                <div class="column is-half has-text-centered">
                    <a @click="show('main')" class="button is-info is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-times"></i>
                        </span>
                        <span>{{ $t("Cancel") }}</span>
                    </a>
                </div>
            </div>
        </div>
        <div v-show="panel == 'results'">
            <p v-if="!results.length">{{ $t("NoResults") }}</p>
            <div v-for="result in results" :key="result.householdID" class="card">
                <div class="card-content">
                    <p class="title is-4 has-text-centered"><i class="fa fa-home"></i> {{ result.name }}</p>
                    <p v-if="result.mobile" class="subtitle is-6 has-text-centered">+{{ result.mobile }}</p>
                    <div v-if="result.address" class="columns is-mobile is-centered">
                        <div class="column is-full has-text-centered">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :title="$t('Address')" :value="result.address" autocomplete="off" readonly disabled>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-map-marker"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns is-mobile is-centered">
                        <div class="column is-full has-text-centered">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :title="$t('WaterSystem')" :value="result.systemName" autocomplete="off" readonly disabled>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-tint"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns is-mobile is-centered">
                        <div class="column is-full has-text-centered">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :title="$t('Tap')" :value="result.assetName" autocomplete="off" readonly disabled>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-tint"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer class="card-footer">
                    <a @click="$router.push({name: 'Household', params: {_householdId: result.householdID, _tab: 'household'}})" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-home"></i>
                        </span>
                        <span>{{ $t("ViewHousehold") }}</span>
                    </a>
                    <a @click="$router.push({name: 'Household', params: {_householdId: result.householdID, _tab: 'tags'}})" class="button is-info is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-tags"></i>
                        </span>
                        <span>{{ $t("ViewTags") }}</span>
                    </a>
                </footer>
            </div>
            <!-- <nav class="pagination">
                <a class="pagination-previous" disabled>Back</a>
                <a class="pagination-next" disabled>Next</a>
                <ul class="pagination-list"></ul>
            </nav> -->
        </div>
      </section>
      <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
import Notification from "@/components/Notification.vue";
import QrScanner from "@/components/QrScanner.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "Search",
  components: {
    Header,
    Modal,
    Notification,
    QrScanner,
    NavigationTabs,
    Spinner
  },
  mounted: async function()
  {
    await this.getWaterSystems();
    await this.updateTaps();
  },
  data () {
      return {
          panel: "main",
          nfcId: null,
          callingCode: "disabled",
          mobile: null,
          name: null,
          address: null,
          lastUsageDateStart: null,
          lastUsageDateEnd: null,
          systemID: "disabled",
          assetID: "disabled",
          assets: [],
          searchId: null,
          results: [],
          page: 1,
          total: null,
          modal: {
              title: null,
              body: null,
              centerBody: true,
              className: "",
              buttons:
              [
                {id: 0, title: this.$t("Yes"), className: "is-info", click: () => { this.modal.className = ""; }}
              ]
          },
          qrScanner: {
              className: ""
          }
      }
  },
  methods:
  {
      show: function(panel)
      {
        this.panel = panel;
      },
      scanQr: function() {
          this.$refs.qrScanner.scanQr();
      },
      qrResult: function(result) {
        const pattern = /^[A-Fa-f0-9]{8}$/;

        if (!pattern.test(result))
        {
            alert(this.$t("ErrorQrCodeDoesntContainATagId"));
            return;
        }

        this.nfcId = result;
      },
      updateTaps: async function()
      {
        if(this.systemID != "disabled")
        {
            const response = await this.$http.get(`/Asset?waterSystemId=${this.systemID}`);
            this.assets = response.data.assets;
        }
      },
      goTo: async function(number)
      {
          if(this.loading)
          {
              return;
          }

          const body =
          {
              searchID: this.searchId,
              page: number
          };

        try
        {
            const response = await this.$http.post(`/Search`, body);
            this.results = response.data.results;
        }

        catch(error)
        {
// eslint-disable-next-line
            console.log(error)
            this.$refs.content.scrollTo(0, 0);
            
            if(error.response)
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: error.response.data.message
                }
            }
            
            else
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: this.$t("Error")
                }
            }
        }
      },
      search: async function()
      {
          if(this.loading)
          {
              return;
          }

          const body = {};

          switch(this.panel)
          {
            case "tag":
                if(!this.$refs.nfcId.checkValidity())
                {
                    this.$refs.nfcId.reportValidity();
                    return;
                }
                body.nfcid = this.nfcId;
                break;

            case "mobile":
                if (this.$refs.callingCode.selectedIndex == 0) {
                    this.$refs.callingCode.selectedIndex = -1;
                }

                if(!this.$refs.callingCode.checkValidity())
                {
                    this.$refs.callingCode.reportValidity();
                    return;
                }
                
                if(!this.$refs.mobile.checkValidity())
                {
                    this.$refs.mobile.reportValidity();
                    return;
                }

                body.callingCode = this.callingCode;
                body.mobile = this.mobile;
                break;

            case "advanced":
                body.nfcid = this.nfcId;

                if(this.callingCode != "disabled")
                {
                    body.callingCode = this.callingCode;
                }

                body.mobile = this.mobile;
                body.name = this.name;
                body.address = this.address;
                body.lastUsageStart = this.lastUsageDateStart;
                body.lastUsageEnd = this.lastUsageDateEnd;

                if(this.assetID != "disabled")
                {
                    body.assetID = this.assetID;
                }

                if(this.systemID != "disabled")
                {
                    body.waterSystemID = this.systemID;
                }

                break;
          }

            try
            {
                if(body.nfcid != null)
                {
                    body.nfcid = body.nfcid.toUpperCase();
                }

                const response = await this.$http.post(`/Search`, body);
                this.searchId = response.data.searchID;
                this.page = response.data.page;
                this.total = response.data.total;
                this.results = response.data.results;
                this.show("results");
            }

            catch(error)
            {
                if(error.response)
                {
                    this.notification =
                    {
                        show: true,
                        className: "is-danger",
                        text: error.response.data.message
                    }
                }
                
                else
                {
                    this.notification =
                    {
                        show: true,
                        className: "is-danger",
                        text: this.$t("Error")
                    }
                }
            }
      }
  }
};
</script>
